/**
 * @module core/widgets/outdated
 */

import {query, setText, setTimeout, window} from '@acng/frontend-bounty';
import {Widget, defineCustomWidget} from '@acng/frontend-stargazer';
import {coreFeature} from '../config/feature';
import {inject} from '../service/ng';

class Outdated extends Widget {
  /** @type {HTMLElement | null} */
  bar = null;
  mseconds = 30000;
  #outdated = this.mseconds;

  async render() {
    var livecam;
    try {
      livecam = inject('Livecam').isActive();
    } catch (err) {
      livecam = false;
    }
    if (livecam) return;
    this.#outdated = this.mseconds + Date.now();
    this.setRemainingSeconds('30');
    window.requestAnimationFrame(this.calc.bind(this));
  }
  click() {
    window.location.reload();
  }
  extend() {
    this.#outdated = this.#outdated + 60 * 1000;
  }
  /**
   * @param {string} value
   */
  setRemainingSeconds(value) {
    const {seconds} = this.elements;
    setText(seconds, value);
  }
  calc() {
    const timeleft = Math.round((this.#outdated - Date.now()) / 1000);

    var p = (100 / this.mseconds) * (this.#outdated - Date.now());
    if (p < 0) window.location.reload();
    if (!this.bar) this.bar = query('.bar');
    if (this.bar) {
      this.bar.style.width = `${p}%`;
    }
    this.setRemainingSeconds(timeleft.toString());
    if (this.#outdated) setTimeout(this.calc.bind(this), 500);
  }
}

defineCustomWidget(coreFeature, 'onsw-outdated', Outdated);
